import { useEffect, useState } from "react";
import { helper } from "lib/helper";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input,
} from "reactstrap";
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper";
import ExportButton from "components/ExportButton";
import usersModel from "models/users.model";
import TableHeader from "components/TableHeader/TableHeader";

const BookingsPage = ({ state }) => {
  const location = useLocation();
  const user = location?.state?.user || null;

  const [isLoading, setIsLoading] = useState(false);
  const [bookingList, setBookingList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const getBookingDetails = async () => {
      const res = await usersModel.getBookingDetails();
      setBookingList(res.data);
    };

    getBookingDetails();

    if (user) {
      setSearchQuery(user.firstName + " " + user.lastName);
    }
  }, [user]);

  const handleDelete = (id) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this booking?", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          const updatedList = bookingList.filter((item) => item._id !== id);
          setBookingList(updatedList);
          helper.sweetalert.toast("Booking deleted successfully!");
        }
      });
  };

  const handleViewMore = (id) => {
    navigate(`/admin/bookings/view/${id}`);
  };

  const handleEdit = (id) => {
    navigate(`/admin/bookings/edit/${id}`);
  };

  const filteredBookingList = filterItems(
    bookingList?.map((e) => ({ ...e.user, ...e })),
    searchQuery,
    [
      "firstName",
      "lastName",
      "mobileNo",
      "_id",
      "duration",
      "bookedOn",
      "paymentMode",
      "totalPayment",
      "experienceDetails",
      "status",
    ]
  ).filter((item) => {
    const statusMatch = statusFilter ? item.status === statusFilter : true;

    const bookingDate = new Date(item.bookingDate);
    const fromMatch = dateFrom ? bookingDate >= new Date(dateFrom) : true;
    const toMatch = dateTo ? bookingDate <= new Date(dateTo) : true;

    return statusMatch && fromMatch && toMatch;
  });

  const columnsConfig = [
    { label: "S.No", getValue: (item, index, currentPage, perPage) => (currentPage - 1) * perPage + index + 1 },
    { label: "Username (Mobile)", getValue: (item) => item?.user?.firstName + " " + item?.user?.lastName + " (" + item?.user?.mobileNo + ")" },
    { label: "Booking ID", getValue: (item) => item._id },
    { label: "Experience Duration", getValue: (item) => item.duration },
    { label: "Booked On", getValue: (item) => new Date(item?.bookingDate).toLocaleDateString("en-GB") },
    { label: "Mode", getValue: (item) => item.paymentMode },
    { label: "Price", getValue: (item) => `₹${item.price}` },
    { label: "Title", getValue: (item) => item?.experience?.title },
    { label: "Status", getValue: (item) => item.status },
  ];

  const options = [
    "#",
    "Username (Mobile)",
    "Booking ID",
    "Experience Time",
    "Booked On",
    "Mode",
    "Price",
    "Title",
    "Status",
    "Actions",
  ];

  return (
    <>
      <Container className="pt-6" fluid>
        <Row>
          <div className="col pl-0 pr-0">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex flex-wrap justify-content-between align-items-center">
                <h3 className="mb-0">User Bookings</h3>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  
                  
                  <div>

                    <lebal className="text-sm">Status</lebal>
                  <Input
                    type="select"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{ width: "160px", marginRight: "10px" }}
                  >
                    <option value="">All Statuses</option>
                    <option value="pending">Pending</option>
                    <option value="invited">Invited</option>
                    <option value="invitAccepted">Invite Accepted</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </Input>
                  </div>
                  <div className=" text-sm">
                    <lebal className="">Form date</lebal>
                    <Input
                    type="date"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  </div>
                  <div className="ml-2">
                    <lebal className=" text-sm">To date</lebal>
                    <Input
                    type="date"
                    value={dateTo}
                    onChange={(e) => setDateTo(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  </div>
                  <div className="ml-2">
                    <lebal className="text-sm">Search</lebal>
                  <Input
                    type="text"
                    placeholder="Search by Username, Booking ID..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ width: "200px", marginRight: "10px" }}
                  />
                  </div>
                
                 
                  <div className="ml-3 mt-4">
                    <ExportButton data={filteredBookingList} columnsConfig={columnsConfig} />
                  </div>
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <TableHeader options={options} />
                <tbody>
                  {filteredBookingList.map((item, index) => (
                    <tr key={item._id}>
                      <td>{(currentPage - 1) * perPage + index + 1}</td>
                      <td>
                        {item?.user?.firstName} {item?.user?.lastName} ({item?.user?.mobileNo})
                      </td>
                      <td>GB00{index + item?._id}</td>
                      <td>
                        {item?.startTime} - {item?.endTime}
                      </td>
                      <td>{new Date(item?.bookingDate).toLocaleDateString("en-GB")}</td>
                      <td>{item?.transaction?.mode || "--"}</td>
                      <td>{item?.transaction?.amount && "₹"}{item?.transaction?.amount?.toFixed(0) || "--"}</td>
                      <td>{item?.experience?.title || item?.experience?.description?.split('').splice(0, 20).join('')}</td>
                      <td>{item?.status}</td>
                      <td>
                        <Button color="success" size="sm" className="mr-2" onClick={() => handleViewMore(item._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </Button>
                        <Button color="warning" size="sm" className="mr-2" onClick={() => handleEdit(item._id)}>
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleDelete(item._id)}>
                          <i className="fa-solid fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  backgroundColor="#DB2777"
                  style={{ backgroundColor: '#DB2777 !important' }}
                  totalPages={Math.ceil(filteredBookingList.length / perPage)}
                  currentPage={currentPage}
                  pageUrl="/admin/bookings?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default BookingsPage;
